import React from "react";

import BardCell from "./BoardCell";
import Menu from "./Menu";
import HighScoreModal from "./HighScoreModal";
import { useGameContext } from "../context/GameContext";
import { RowType } from "../types/types";
import "./Board.css";

interface Props {
  board: any;
  resetGameStats: any;
  highScore: any;
  setHighScore: any;
  resetBoard: any;
  gameStats: any;
}

const Board: React.FC<Props> = ({
  board,
  resetGameStats,
  highScore,
  setHighScore,
  resetBoard,
  gameStats,
}) => {
  const { gameOver, isGameLobby } = useGameContext();

  const boardStyles = {
    gridTemplateRows: `repeat(${board.size.rows}, 1fr)`,
    gridTemplateColumns: `repeat(${board.size.columns}, 1fr)`,
  };

  return (
    <div className="Board" style={boardStyles}>
      {gameOver && highScore > 0 && (
        <HighScoreModal gameStats={gameStats} setHighScore={setHighScore} />
      )}

      {gameOver && !highScore && (
        <Menu resetGameStats={resetGameStats} resetBoard={resetBoard} />
      )}

      {!isGameLobby &&
        board.rows.map((row: RowType[], y: number) => {
          return row.map((cell: any, x: number) => {
            return <BardCell key={x * board.size.columns + x} cell={cell} />;
          });
        })}
    </div>
  );
};

export default Board;
